"use strict";



//////////////////
// WEBPACK FOOTER
// ./~/memoizee/lib/registered-extensions.js
// module id = 190
// module chunks = 0